import React from 'react';
import PropTypes from 'prop-types';
import { Box, Collapse, Icon, IconButton, Typography } from '@material-ui/core';
import { useControlled } from '@material-ui/core/utils';
import { makeStyles } from '@material-ui/styles';
import FlowCard from './FlowCard';

const useStyles = makeStyles((theme) => ({
  summary: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  expand: {
    transitionDuration: theme.transitions.duration.standard,
  },
  expandRotate135: {
    transform: 'rotate(135deg)',
    transitionDuration: theme.transitions.duration.standard,
  },
  expandRotate180: {
    transform: 'rotate(180deg)',
    transitionDuration: theme.transitions.duration.standard,
  },
}));

const FlowCardAccordion = ({
  children,
  icon = 'add_circle_outlined',
  isIcon = true,
  title,
  expanded,
  defaultExpanded,
  onChange,
}) => {
  const [open, setOpen] = useControlled({
    controlled: expanded,
    default: defaultExpanded,
    name: 'FlowCardAccordian',
    state: 'expanded',
  });

  const handleChange = (e) => {
    setOpen(!open);
    if (onChange) {
      onChange(e);
    }
  };

  const classes = useStyles();
  return (
    <FlowCard>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        onClick={handleChange}
        className={classes.summary}
      >
        {typeof title === 'string' ? (
          <Typography variant="overline">{title}</Typography>
        ) : (
          title
        )}
        {isIcon &&
          (icon === 'add_circle_outlined' ? (
            <IconButton color="primary">
              <Icon className={open ? classes.expandRotate135 : classes.expand}>
                {icon}
              </Icon>
            </IconButton>
          ) : (
            <IconButton color="primary">
              <Icon className={open ? classes.expandRotate180 : classes.expand}>
                {icon}
              </Icon>
            </IconButton>
          ))}
      </Box>
      <Collapse in={open} unmountOnExit>
        <Box mt={1}>{children}</Box>
      </Collapse>
    </FlowCard>
  );
};

FlowCardAccordion.propTypes = {
  children: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  icon: PropTypes.string,
  isIcon: PropTypes.bool,
  onChange: PropTypes.func,
  expanded: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
};

export default FlowCardAccordion;
